/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The ReservationSale model module.
 * @module model/ReservationSale
 * @version 1.0.0
 */
export default class ReservationSale {
  /**
   * Constructs a new <code>ReservationSale</code>.
   * @alias module:model/ReservationSale
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>ReservationSale</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReservationSale} obj Optional instance to populate.
   * @return {module:model/ReservationSale} The populated <code>ReservationSale</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReservationSale()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('transaction_head_id')) {
        obj['transaction_head_id'] = ApiClient.convertToType(data['transaction_head_id'], 'Number')
      }
      if (data.hasOwnProperty('reservation_id')) {
        obj['reservation_id'] = ApiClient.convertToType(data['reservation_id'], 'Number')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} transaction_head_id
   */
  transaction_head_id = undefined
  /**
   * @member {Number} reservation_id
   */
  reservation_id = undefined
}
